import { bibleRule, emojiRule, hashTagRule, urlRule, usernameRule } from "./TagRules";

export async function textTransform(text, post) {
  if (!text) {
    return text;
  }

  const rules = [usernameRule(), hashTagRule(), emojiRule(), urlRule(), bibleRule(post)];

  const references = [];

  await Promise.all(rules.map(rule => rule.transform(text, references)));

  let finalText = text;
  let offset = 0;

  references.sort((a, b) => {
    return a.start - b.start;
  });

  references.forEach(match => {
    finalText =
      finalText.substring(0, match.start + offset) + match.replacement + finalText.substring(match.end + offset);

    offset += match.replacement.length - match.text.length;
  });

  return finalText;
}

export function rule(regex, transformer) {
  return {
    transform: async (text, references) => {
      const expr = new RegExp(regex);
      let match;
      while ((match = expr.exec(text)) != null) {
        const textMatch = match[0];
        const start = match.index;
        const end = start + textMatch.length;
        const replacement = await transformer(textMatch, text, references);

        references.push({ text: textMatch, start, end, replacement });
      }
    }
  };
}
